import { RouterView } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';
import { authGuard, notAuthGuard } from '../guards';

export const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: () => import('../../layouts/default-layout.vue'),
    meta: {
      guards: [authGuard],
    },
    children: [
      {
        path: '',
        redirect: '/inventory',
      },
      {
        path: '/replenishment',
        name: 'replenishment',
        component: () => import('../../views/replenishment/replenishment-index.vue'),
        redirect: '/replenishment/overview',
        children: [
          {
            path: 'overview',
            component: () => import('../../views/replenishment/replenishment-overview.vue'),
          },
          {
            path: 'store',
            component: () => import('../../views/replenishment/replenishment-store.vue'),
          },
          {
            path: 'product',
            component: () => import('../../views/replenishment/replenishment-product.vue'),
          },
          {
            path: 'inventories',
            component: () => import('../../views/replenishment/replenishment-inventories.vue'),
          },
        ],
      },
      {
        path: '/analytics',
        name: 'analytics',
        component: () => import('../../views/analytics/analytics-index.vue'),
        children: [
          {
            path: 'dashboards/:id',
            name: 'analytics-dashboard',
            component: () => import('../../views/analytics/analytics-dashboard.vue'),
          },
        ],
      },
      {
        path: '/analytics-embedded',
        name: 'analytics-embedded',
        component: () => import('../../views/analytics-embedded/analytics-index.vue'),
        children: [
          {
            path: 'dashboards/:id',
            name: 'analytics-embedded-dashboard',
            component: () => import('../../views/analytics-embedded/analytics-dashboard.vue'),
          },
        ],
      },
      {
        path: '/inventory',
        component: RouterView,
        children: [
          {
            path: '',
            component: () => import('../../views/inventory/inventory-index.vue'),
            redirect: '/inventory/location',
            children: [
              {
                path: 'location',
                component: () => import('../../views/inventory/inventory-location.vue'),
              },
              {
                path: 'sku',
                component: () => import('../../views/inventory/inventory-sku.vue'),
              },
              // TODO: remove this fallback redirect in 2024
              {
                path: 'sku-location',
                redirect: (to) => ({
                  path: '/inventory/inventories',
                  query: to.query,
                }),
              },
              {
                path: 'inventories',
                component: () => import('../../views/inventory/inventory-inventories.vue'),
              },
            ],
          },
          {
            path: 'inventories/:id',
            component: () => import('../../modules/sku-chart/views/sku-chart.vue'),
            props: {
              breadcrumbs: ['inventory', 'inventories'],
            },
          },
        ],
      },
      {
        path: '/special-events',
        name: 'special_events',
        component: () => import('../../views/special-events/special-events.vue'),
      },
      {
        path: '/store-transfer',
        component: () => import('../../views/store-transfer/store-transfer-index.vue'),
        redirect: '/store-transfer/recommendations',
        children: [
          {
            path: 'recommendations',
            component: () =>
              import('../../views/store-transfer/store-transfer-recommendations.vue'),
            redirect: '/store-transfer/recommendations/trips',
            children: [
              {
                path: 'trips',
                component: () =>
                  import('../../views/store-transfer/store-transfer-recommendations-trips.vue'),
              },
              {
                path: 'products',
                component: () =>
                  import('../../views/store-transfer/store-transfer-recommendations-products.vue'),
              },
            ],
          },
          {
            path: 'transfers',
            component: () => import('../../views/store-transfer/store-transfer-transfers.vue'),
          },
        ],
      },
    ],
  },
  {
    path: '/auth',
    name: 'auth',
    meta: {
      guards: [notAuthGuard],
    },
    component: () => import('../../views/auth-page.vue'),
  },
  {
    path: '/:catchAll(.*)',
    name: '404',
    component: () => import('../../views/not-found.vue'),
  },
];
